import React from 'react';

/**
 * AppDownloadBanner — Removed for all users per D9a (Sept audit decision).
 * Kept as a no-op component so existing imports/tests continue to resolve cleanly.
 */
const AppDownloadBanner = () => null;

export default AppDownloadBanner;
